import React from 'react';
import List from '@mui/material/List';

type SidenavListProps = {
  children: React.ReactNode;
};

function SidenavList({ children }: SidenavListProps) {
  return (
    <List
      sx={{
        px: 1.5,
        my: 0.3,
      }}
    >
      {children}
    </List>
  );
}

export { SidenavList };
